import { render, staticRenderFns } from "./ProjectPlannedResourcesWorkTypePeriod.vue?vue&type=template&id=24ca2029&scoped=true&"
import script from "./ProjectPlannedResourcesWorkTypePeriod.vue?vue&type=script&lang=js&"
export * from "./ProjectPlannedResourcesWorkTypePeriod.vue?vue&type=script&lang=js&"
import style0 from "./ProjectPlannedResourcesWorkTypePeriod.vue?vue&type=style&index=0&id=24ca2029&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ca2029",
  null
  
)

export default component.exports